import React from 'react'
import { Shortcuts } from 'react-shortcuts'
import { withProps } from 'recompose'

export default (namespace, handler, extraProps) => Component => props => (
  <Shortcuts
    name={namespace}
    handler={handler(props)}
    targetNodeSelector="body"
    stopPropagation={false}
    className="react-shortcuts"
    {...extraProps}
  >
    <Component {...props} />
  </Shortcuts>
)

export const withShortcuts = (namespace, handler, extraProps) =>
  withProps(props => ({
    Shortcuts: () => (
      <Shortcuts
        name={namespace}
        handler={handler(props)}
        targetNodeSelector="body"
        stopPropagation={false}
        className="react-shortcuts"
        {...extraProps}
      />
    )
  }))
